var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"logo-size",attrs:{"src":_vm.logo || _vm.default_logo,"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }